import React from 'react';

export const akunSubChildCategoryTable = (handleEdit, handleDelete) => {
    return [
        {
            title : "id_akun_sub_child_kategori",
            render : rowData => {
                return <span>{rowData.id_akun_sub_child_kategori}</span>
            }
        },
        {
            title : "Akun Sub Child Kategori",
            render : rowData => {
                return <span>{rowData.sub_child_kategori_akun}</span>
            }
        },
        {
            title : "id_akun_sub_kategori",
            render : rowData => {
                return <span>{rowData.id_akun_sub_kategori}</span>
            }
        },
        {
            title : "Akun Sub Kategori",
            render : rowData => {
                return <span>{rowData.sub_kategori_akun}</span>
            }
        },
        {
            title : "id_akun_kategori",
            render : rowData => {
                return <span>{rowData.id_akun_kategori}</span>
            }
        },
        {
            title : "Akun Kategori",
            render : rowData => {
                return <span>{rowData.kategori_akun}</span>
            }
        },
        {
            title : "Created At",
            render : rowData => {
                return <span>{rowData.created_at}</span>
            }
        },
        {
            title : "Updated At",
            render : rowData => {
                return <span>{rowData.updated_at}</span>
            }
        },
        {
            title : "Action",
            render : rowData => {
                return (
                    <>
                        <button 
                            className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleEdit(rowData)}
                        >
                        Edit
                        </button>
                        <button
                            className='bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded'
                            onClick={(e) => handleDelete(rowData)}
                        >
                        Delete
                        </button>
                    </>
                )
            }
        }
    ]
}